import {Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {partnerListSelector} from '../../partner/partner.reducer';
import {AppStore} from '../../store/store';
import {TargetSystemModel} from '../../target/target-system.model';
import {DistributionAccountModel} from '../distribution-account.model';
import {targetSystemListSelector} from '../distribution-account.reducer';
import {DistributionAccountListViewModel} from './list.model';
import {DistributionAccountEditComponent} from '../edit/edit.component';
import {MatDialog} from '@angular/material/dialog';
import {SubSink} from 'subsink';

@Component({
  selector: 'app-distribution-accounts-list',
  template: `
    <div class="shadowed">
      <div>
        <div class="table-caption">

          <h5 class="mat-title">Distribution Accounts</h5>

          <div class="flex-spacer"></div>

          <button #distributionAccountCreate (click)="create()" id="btn-add-distribution-account" mat-mini-fab
                  matTooltip="Add" name="create-distribution-account">
            <mat-icon>add</mat-icon>
          </button>

        </div>
      </div>

      <mat-table
        id="table-distribution-account-list"
        [dataSource]="dataSource"
        data-cy="element-distribution-account-list"
        matSort
        matSortActive="targetSystemId"
        matSortDirection="asc">

        <ng-container matColumnDef="targetSystem">
          <mat-header-cell *matHeaderCellDef mat-sort-header="targetSystemId"
                           sortActionDescription="Sort by target system"> Target System
          </mat-header-cell>
          <mat-cell *matCellDef="let segment"> {{segment.targetSystemId}} - {{segment.targetSystemName}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="description">
          <mat-header-cell *matHeaderCellDef mat-sort-header="segment.description"
                           sortActionDescription="Sort by description"> Description
          </mat-header-cell>
          <mat-cell *matCellDef="let segment"> {{segment.id}} - {{segment.description}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="foreignAccountId">
          <mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by foreign account id"> Foreign
            Account Id
          </mat-header-cell>
          <mat-cell *matCellDef="let segment"> {{segment.foreignAccountId}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="partnerId">
          <mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by partner id"> Partner Id
          </mat-header-cell>
          <mat-cell *matCellDef="let segment"> {{segment.partnerId}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="visibleForAll">
          <mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by visible for all"> Visible to
            all
          </mat-header-cell>
          <mat-cell *matCellDef="let segment"> {{segment.visibleForAll}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="edit">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell *matCellDef="let segment">
            <div (click)="editAccount(segment.id)">
              <mat-icon>edit</mat-icon>
            </div>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
        <mat-row *matRowDef="let segment; columns: displayedColumns;">
        </mat-row>
      </mat-table>

    </div>
  `,
  styleUrls: ['list.component.scss']
})
export class DistributionAccountListComponent implements OnInit, OnDestroy {
  @ViewChild(MatSort, {static: true}) sort!: MatSort;

  items: DistributionAccountListViewModel[] = [];
  subsink = new SubSink();
  @Output() showCreateDialog = new EventEmitter<DistributionAccountModel>();

  displayedColumns: string[] = ['targetSystem', 'description', 'foreignAccountId', 'partnerId', 'visibleForAll', 'edit'];
  dataSource: MatTableDataSource<DistributionAccountListViewModel> = new MatTableDataSource<DistributionAccountListViewModel>();

  constructor(private appStore: AppStore,
              private dialog: MatDialog) {
  }

  ngOnInit(): void {
    this.dataSource.sort = this.sort;

    this.extractTargetSystems(this.appStore.getState());

    this.subsink.sink = this.appStore.subscribe((state: AppStore) => this.extractTargetSystems(state));
  }

  create() {
    this.showCreateDialog.emit();
  }

  editAccount(id: number) {
    this.dialog.open(DistributionAccountEditComponent, {
      data: {distributionAccountId: id},
    });
  }

  ngOnDestroy(): void {
    this.subsink.unsubscribe();
  }

  private extractTargetSystems(state: AppStore) {
    this.items.length = 0;
    const partnerNames: { [key: number]: string; } = {};
    const partners = partnerListSelector(this.appStore.getState());
    for (let i = partners.length - 1; i >= 0; i--) {
      partnerNames[partners[i].id] = partners[i].name;
    }

    targetSystemListSelector(state).forEach((targetSystem: TargetSystemModel) => {
      targetSystem.distributionAccounts?.forEach((distributionAccount: DistributionAccountModel) => {
        this.items.push(new DistributionAccountListViewModel(targetSystem, distributionAccount, partnerNames));
      });
    });

    this.dataSource.data = this.items;
  }
}
